import { MdArrowForward } from "react-icons/md";
import Button from "./Button";
import Spinner from "../spinner/Spinner";
import TranslatableText from "../translations/TranslatableText";
import { TranslationKey } from "../../types/modulesInterfaces";

interface LoginButtonProps {
    isLoading?: boolean;
    translationKey?: TranslationKey;
    type?: "button" | "submit" | "reset";
    disabled?: boolean;
    onClick?: () => void;
}

const LoginButton = ({
    isLoading = false,
    translationKey = "main.login",
    type = "submit",
    disabled = false,
    onClick
}: LoginButtonProps) => {
    return (
        <Button type={type} className="btn-login" disabled={disabled} onClick={onClick}>
            <TranslatableText className="bg-quat-de label" translationKey={translationKey} />
            <div className="bg-quat-br icon">
                {isLoading ? (
                    <Spinner size={36} padding={8} />
                ) : (
                    <MdArrowForward size={20} color="var(--light-gray)" />
                )}
            </div>
        </Button>
    );
};

export default LoginButton; 